import { Button, ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@mui/material';
import React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { TermSheetFacilityFee } from '../../../shared/models';

interface FeeActionButtonProps {
	fee: TermSheetFacilityFee;
	onEdit: (fee: TermSheetFacilityFee) => void;
	onDelete: (fee: TermSheetFacilityFee) => void;
	openNotes: (fee: TermSheetFacilityFee) => void;
}

type FeeActionItem = keyof typeof FeeActionItemMap;
const FeeActionItemMap = {
	Notes: 'Notes',
	Edit: 'Edit',
	Delete: 'Delete',
};

export const FeeActionButton: React.FC<FeeActionButtonProps> = ({ fee, onEdit, onDelete, openNotes }) => {
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef<HTMLDivElement>(null);

	const handleToggle = () => {
		setOpen(prevOpen => !prevOpen);
	};

	const handleClick = (action: FeeActionItem) => {
		switch (action) {
			case 'Notes':
				openNotes(fee);
				break;
			case 'Edit':
				onEdit(fee);
				break;
			case 'Delete':
				onDelete(fee);
				break;
		}
	};

	const handleClose = (event: Event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
			return;
		}

		setOpen(false);
	};

	const handleMenuItemClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>, actionItem: FeeActionItem) => {
		setOpen(false);
		handleClick(actionItem);
	};

	return (
		<>
			<ButtonGroup variant="contained" ref={anchorRef} aria-label="split button">
				<Button onClick={handleToggle}>Actions</Button>
				<Button
					size="small"
					aria-controls={open ? 'split-button-menu' : undefined}
					aria-expanded={open ? 'true' : undefined}
					aria-label="select merge strategy"
					aria-haspopup="menu"
					onClick={handleToggle}
				>
					<ArrowDropDownIcon />
				</Button>
			</ButtonGroup>
			<Popper
				open={open}
				style={{ zIndex: 1000, margin: 0 }}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
						}}
					>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList id="split-button-menu" autoFocusItem>
									{fee.guid !== undefined && fee.guid !== null && 
										(<MenuItem onClick={event => handleMenuItemClick(event, 'Notes')}>
											{FeeActionItemMap['Notes']}
										</MenuItem>)
									}
									<MenuItem onClick={event => handleMenuItemClick(event, 'Edit')}>
										{FeeActionItemMap['Edit']}
									</MenuItem>
									<MenuItem onClick={event => handleMenuItemClick(event, 'Delete')}>
										{FeeActionItemMap['Delete']}
									</MenuItem>
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</>
	);
};
